<template>
    <formulateInput
        :label="label"
        :name="name"
        :placeholder="placeholder"
        type="vue-select-async"
        :validation="validation"
        :disabled="setDisabled"
        :apiData="{
            resource: 'actions',
            fields: { actions: 'title' },
            fieldsMapping: {
                label: 'title',
                value: 'id',
            },
        }"
        :options="options"
        @update:input="$emit('update:input', $event)"
        @update:options="$emit('update:options', $event)"
    />
</template>

<script>
export default {
    name: "SelectAction",
    props: {
        options: {
            required: false,
            type: Array,
            default() {
                return []
            },
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: false,
            default: "action",
        },
        validation: {
            type: String,
            required: false,
            default: "optional",
        },
        setDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
}
</script>

<style scoped></style>
